import { useQuery } from "react-query";
import { reportApi } from "../api/report-api";
import { SLAPeriodPayload } from "../types/report/sla";

export enum ReportQueryKey {
  SLASummary = "SLASummary",
  SLAByWorker = "SLAByWorker",
  SLAByScheduleLine = "SLAByScheduleLine",
  SLAIssuesSummary = "SLAIssuesSummary",
}

const periodKey = (p: SLAPeriodPayload) => [
  p.fromDate,
  p.toDate,
  p.clientId ?? "",
  p.agencyId ?? "",
];

export const useSLASummaryQuery = (payload: SLAPeriodPayload, enabled = true) =>
  useQuery(
    [ReportQueryKey.SLASummary, ...periodKey(payload)],
    () => reportApi.getSummary(payload),
    { enabled },
  );

export const useSLAByWorkerQuery = (payload: SLAPeriodPayload, enabled = true) =>
  useQuery(
    [ReportQueryKey.SLAByWorker, ...periodKey(payload)],
    () => reportApi.getByWorker(payload),
    { enabled },
  );

export const useSLAByScheduleLineQuery = (
  payload: SLAPeriodPayload,
  enabled = true,
) =>
  useQuery(
    [ReportQueryKey.SLAByScheduleLine, ...periodKey(payload)],
    () => reportApi.getByScheduleLine(payload),
    { enabled },
  );

export const useSLAIssuesSummaryQuery = (
  payload: SLAPeriodPayload,
  enabled = true,
) =>
  useQuery(
    [ReportQueryKey.SLAIssuesSummary, ...periodKey(payload)],
    () => reportApi.getIssuesSummary(payload),
    { enabled },
  );
